module.exports = __webpack_public_path__ + "img/popshop-bg.791e6fc7.jpg";